<template>
  <div class="box box-1" :class="{ 'ani-scale': !isMobileSize }" @click="$emit('openVideo', 1)">
    <img class="img-1" :src="img1" alt="" />
    <img class="add-icon" :src="addIcon2" alt="" />
    <div class="title">{{ $t('keypalTwo.introduce.desc_2') }}</div>
    <div class="desc">{{ $t('keypalTwo.introduce.desc_10') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      width: 0,
      heigh: 0,
    };
  },
  computed: {
    ...mapGetters(['isMobileSize']),
    img1() {
      return require('../../assets/images/keypal-two/introduce-1.png');
    },
    addIcon2() {
      return require('../../assets/images/keypal-two/add-2.png');
    },
  },
  mounted() {
    // window.addEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth < 1200) {
        const radio = 727 / 1200;
        const cRadio = window.innerWidth / (window.innerWidth * radio);
        console.log('radio', window.innerWidth * radio);
        
        this.width = 384 * cRadio;
        this.heigh = 500 * cRadio;
        // console.log('width', this.width);
        // console.log('heigh', this.heigh);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./card.scss');
.box-1 {
  width: 384px;
  height: 500px;

  .img-1 {
    width: 384px;
    height: 500px;
    object-fit: cover;
  }

  .title {
    color: #ffffff;
  }

  .desc {
    color: #ffffff;
    max-width: none;
  }
}

@media screen and (max-width: 1200px) {
  .box-1 {
    width: calc(384 / 1300 * 100vw);
    height: calc(500 / 1300 * 100vw);
    .img-1 {
      width: calc(384 / 1300 * 100vw);
      height: calc(500 / 1300 * 100vw);
      object-fit: cover;
    }
  }
}

@media screen and (max-width: 767px) {
  .box-1 {
    width: 276px;
    height: auto;
    overflow: hidden;
    .title {
      left: 23px;
      top: 23px;
      color: #ffffff;
    }

    .desc {
      color: #ffffff;
    }

    .img-1 {
      width: 276px;
      height: 419px;
    }
  }
}
</style>
